// Remote 모듈 라우트 — AppShell children 으로 주입되어 Content(router-view)에 렌더된다.
// 소켓은 앱 전역(로그인~로그아웃)에서 Core 가 관리하므로 라우트별 연결 가드는 두지 않는다.

export default [
  {
    path: "/remote/dashboard",
    name: "RemoteDashboard",
    component: () => import("./views/RemoteDashboard.vue"),
    meta: { title: "Dashboard", perm: "REMOTE_APP" },
  },
  {
    path: "/remote/history",
    name: "RemoteHistory",
    component: () => import("./views/RemoteHistory.vue"),
    meta: { title: "Collaboration History", perm: "REMOTE_APP" },
  },
  {
    path: "/remote/settings",
    name: "RemoteSettings",
    component: () => import("./views/RemoteSettings.vue"),
    meta: { title: "Environment Setting", perm: "REMOTE_APP" },
  },
  {
    path: "/remote/members",
    name: "RemoteMember",
    component: () => import("./views/RemoteMember.vue"),
    meta: { title: "Member Search", perm: "REMOTE_APP" },
  },
  // 협업 Zone (실시간: Janus 영상/채팅). 협업 Space/입장 시 이동.
  {
    path: "/remote/zone/:arSpaceIdx?",
    name: "RemoteZone",
    component: () => import("./views/RemoteManagementMain.vue"),
    meta: { title: "협업 Zone", perm: "REMOTE_APP" },
    // 직접 로드(탭 복원 Ctrl+Shift+T · 새로고침 F5 · 주소 직접입력)는 in-app 진입이 아니다.
    // 이 경우 Zone 으로 바로 들어와 stale localStorage 로 조용히 재입장하면 안 되므로,
    // 대시보드로 보내 재접속 흐름(checkInterruptedRemote)이 유효성 확인 후 처리하게 한다.
    // (in-app 이동은 from.name 이 있으므로 그대로 통과)
    beforeEnter: (to, from) => {
      if (!from.name) {
        return { path: "/remote/dashboard" };
      }
    },
  },
  // 화면 공유 뷰 (별도 창)
  {
    path: "/remote/screen",
    name: "RemoteScreenView",
    component: () => import("./views/ScreenView.vue"),
    meta: { title: "Screen", perm: "REMOTE_APP" },
  },
  // 게스트 공유 링크 참여 (Zoom식) — 짧은 형태 /remote/{token}.
  // 정적 /remote/* 경로(dashboard·zone·screen 등)가 우선순위가 높아 충돌하지 않고,
  // 알려지지 않은 단일 세그먼트만 토큰으로 처리한다. 이전 형태(/remote/zone/join/:token)는 alias 로 유지.
  // 토큰 해석 후 리다이렉트만 하므로 component 는 렌더되지 않는다(형식상 지정).
  // (join 을 여기 가드에서 끝내 localStorage 를 채워야, 이어지는 created()/mounted() 흐름이 그대로 동작)
  {
    path: "/remote/:token",
    alias: "/remote/zone/join/:token",
    name: "RemoteZoneJoin",
    // 게스트 공유 링크 랜딩. 모바일(Android)이면 앱 실행/스토어 유도 인터스티셜,
    // 그 외(데스크톱/iOS)는 바로 웹 join. 토큰 해석·로그인·입장은 랜딩 컴포넌트가 처리.
    // public: 로그인 전에도 "앱으로 열기" 인터스티셜을 보여줘야 하므로 전역 가드에서 공개 처리.
    // (토큰 자체가 Zone 입장 인가라 REMOTE_APP 모듈 권한도 요구하지 않음)
    component: () => import("./views/RemoteShareLanding.vue"),
    meta: { title: "협업 Zone", public: true },
  },
];
